import t from 'react-translate';
import { CellProps } from './types';
import { useCallback } from 'react';
import NvTooltip from 'shared/components/nv-tooltip';
import NvSwitch from 'shared/components/inputs/nv-switch';
import { config } from '@config/pendo.config.json';
import { updateCustomCommunication } from 'redux/actions/mentorship-program-custom-communications';
import { useAppDispatch } from 'redux/store';

const StatusCell = ({ cell }: CellProps) => {
  const dispatch = useAppDispatch();
  const status = cell.getValue() as boolean;
  const {
    row: { original: mentorshipProgramCommunication },
  } = cell;
  const translationBase = t.MENTORING_PROGRAMS.COMMUNICATIONS.TABLE.STATUS;
  const TOOLTIP_TEXT: Record<string, string> = {
    true: translationBase.TURN_COMMUNICATION_OFF(),
    false: translationBase.TURN_COMMUNICATION_ON(),
  };
  const dataQATag =
    config.pendo.athena.mentorshipProgram.communications
      .toggleCommunicationStatus;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>, newStatus: boolean) => {
      e.stopPropagation();
      dispatch(
        updateCustomCommunication({
          programId: mentorshipProgramCommunication.mentorshipProgramId,
          communicationId: mentorshipProgramCommunication.id,
          enabled: newStatus,
        })
      );
    },
    [dispatch, mentorshipProgramCommunication]
  );

  return (
    <NvTooltip preventOverflow={false} text={TOOLTIP_TEXT[String(status)]}>
      <NvSwitch
        checked={status}
        onClick={handleClick}
        enabledLabel={t.SHARED.ON().toUpperCase()}
        disabledLabel={t.SHARED.OFF().toUpperCase()}
        dataQa={dataQATag}
        dataQaId={`${dataQATag}-${mentorshipProgramCommunication.id}`}
        aria-label={TOOLTIP_TEXT[String(status)]}
      />
    </NvTooltip>
  );
};

export default StatusCell;
